/**
 * User-facing copy for "snippet mastered" — matches {@link isCardMastered} in SRS/algorithm.js.
 * Mastered is separate from "snippet complete" (exact match) and from SRS due/up-to-date dots.
 */

/** Full definition — docs and dedicated help surfaces only, not count-pill hovers. */
export const SNIPPET_MASTERY_DEFINITION =
  'Proven retention over multiple reviews across at least a week. Long-interval reviews (e.g. 90d) continue to keep syntax fresh.';

export const SNIPPET_MASTERY_LABEL = 'Mastered';

/** Short hover hint for mastered badges and stat pills. */
export const SNIPPET_MASTERY_TOOLTIP = 'Snippets Mastered';

/** Short visible label for community-likes stat pills. */
export const COMMUNITY_LIKES_LABEL = 'Likes';

/** Empty-state hint when the user has no mastered snippets yet. */
export const SNIPPET_MASTERY_EMPTY_HINT =
  'Keep reviewing — mastery needs multiple successful reviews over at least a week.';

/**
 * Concise hover title for mastered count pills (no definition appended).
 * @param {number} mastered
 * @param {number} total
 * @param {string} [suffix] e.g. " · Continue learning"
 */
export function formatSnippetMasteryCountTitle(mastered, total, suffix = '') {
  const ratio = `${mastered}/${total} snippets mastered`;
  return suffix ? `${ratio}${suffix}` : ratio;
}

/**
 * @param {number} mastered
 * @param {number} total
 * @param {string} [suffix]
 */
export function formatSnippetMasteryCountAria(mastered, total, suffix = '') {
  return `Mastered ${mastered} of ${total} snippets${suffix}`;
}

/**
 * @param {number} count
 */
export function formatSnippetsMasteredProfileAria(count) {
  return `Snippets mastered across all languages: ${count}`;
}
